<main class="d-flex align-items-center min-vh-100 py-3 py-md-0">

  <div class="container">
    <div class="card">
      <div class="row no-gutters">
        <div class="col-md-6 align-middle left-wrapper">
          <div class="d-flex align-items-center flex-column login-card">
            <img src="../../edmsui/assets/images/landing-img.png" class="text-center" width="130" alt="Landing Image">
            <p class="text-white ff-1 fs-25 eip-pt-20 eip-pb-10">Welcome To EDMS
            </p>
            <img width="150" src="../../edmsui/assets/images/L&T-Logo.png" alt="Footer Logo">
          </div>
        </div>
        <div class="col-md-6 right-wrapper">
          <div class="card-body">
            <div class="brand-wrapper">
              <div class="logo">
                <h4 class="logo-title ff-2">EDMS 4.0</h4>

              </div>
            </div>
            <div class="login-container">
              <form (ngSubmit)="onSubmit()" [formGroup]="loginForm" autocomplete="off">
                <div class="login-tab-container mt-3">
                  <mat-tab-group (selectedTabChange)="onTabClick($event)">
                    <mat-tab label="Employee">
                      <div>
                        <img src="../../edmsui/assets/images/user.svg" width="158" alt="Employee-Icon"
                          class="mx-auto d-block user-logo" alt="Landing Image">
                      </div>
                      <div>
                        <input (click)="onSubmit()" name="internalLogin" id="internalLogin"
                          class="btn btn-primary login-btn mb-2" type="button" value="Login">
                        <!-- <p class="forgot-password-link eip-link mb-1">Forgot password?</p> -->
                      </div>
                      <p id="myButton" (click)="togglePopup()" class="copyright"
                        style="text-decoration: underline;color: #1579ab;">Download Mobile App</p>
                      <div class="popup" [style.display]="isPopupVisible ? 'block' : 'none'">
                        <div class="popup-content">
                          <span class="close" (click)="togglePopup()">&times;</span>
                          <p style="color:red;font-size: 16px;">Note : this application is for Android devices.
                          </p>
                          <img src="assets/images/edms_qr.png" alt="edmsapk-qrcode" class="qr-img" /><br>
                          <p> <span class="or-text">or</span></p>
                          <p style="font-size: 16px;">click <a href="https://eipvidhya.lntecc.com/gn/AppStore/EDMS%20Mobile%20App/Forms/AllItems.aspx?RootFolder=%2Fgn%2FAppStore%2FEDMS%20Mobile%20App%2FEDMS%204.O%20Mobile%20App&FolderCTID=0x012000E09E85729F34D74E8213B6E610C0E706&View={544F0B0C-45EA-4A29-A14F-DE55CD80792A}"
                              style="outline: none;color: #003D73;" target="
                  "><strong>here</strong></a> to download</p>
                        </div>
                      </div>
                    </mat-tab>
                    <mat-tab label="Other User">
                      <div class="pt-4">
                        <mat-form-field style="width: 100%;">
                          <label for="username" class="login-label">User Name</label>
                          <input matInput type="text" name="username" id="username" tabindex="1" #u class="form-control"
                            formControlName="username" value="" (paste)="$event.preventDefault()"
                            (copy)="$event.preventDefault()" autocomplete="new-password" required>
                          <mat-error *ngIf="loginForm.get('username').hasError('required')">
                            User name is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="pt-2">
                        <mat-form-field style="width: 100%;">
                          <label for="password" class="login-label">Password</label>
                          <input matInput type="password" name="password" id="password" maxlength="128" tabindex="2"
                            formControlName="password" class="form-control" #x (paste)="$event.preventDefault()"
                            value="" (copy)="$event.preventDefault()" autocomplete="new-password" required>
                          <span class="field-icon"
                            [className]="x.type == 'password' ? 'fa fa-eye-slash field-icon' : 'fa fa-eye field-icon'"
                            (mouseup)="x.type = 'password'" (mousedown)="x.type='text'"
                            (mouseleave)="x.type = 'password'"></span>
                          <mat-error *ngIf="loginForm.get('password').hasError('required')">
                            Password is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <input [disabled]="!loginForm.valid || isSubmitted" (click)="onSubmit()" name="externalLogin"
                        id="externalLogin" class="btn btn-primary login-btn mt-2 mb-2" type="submit" value="Login">
                      <mat-progress-bar *ngIf="isSubmitted" mode="indeterminate"
                        style=" width: 100% !important; height: 2% !important;"></mat-progress-bar>
                      <p class="forgot-password-link eip-link mb-1" (click)="forgetPwd()">Forgot or Change password</p>
                    </mat-tab>
                  </mat-tab-group>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
      </div>
      <div class="col-md-6">
        <p class="copyright">EDMS &copy; {{ currentYear }} L&T Construction. All Rights Reserved.</p>
      </div>
    </div>
    <br>
    <!-- <div class="row">
      <div class="col-sm-12 text-center">
        <marquee style="color: #003D73; font-weight: bold; font-size: 16px; ">
          <span style="background-color: #FFFF00;"> &nbsp; We are in the process of migrating Projects from EDMS 2.0 to 4.0. In case of any difficulties during this process, please contact S&PI (Chandan / Hari Priya) / Dev Team (HemaBhushan / Mukesh). </span>
      </marquee>      
      </div>
    </div> -->
  </div>
</main>